import { APIGetRequest } from "@/utils/requests";
import { CollectionWithCountAndFeaturedSpecial } from "@/data/v2/models/collections";
import { logException } from "@/analytics/sentry";

export type GetCollectionsParams = {
  collectionId?: string;
  comedianId?: string;
  paid?: boolean;
  kind?: "collection" | "podcast";
  limit?: number;
  specialsLimit?: number;
};

export async function getCollections(
  params: GetCollectionsParams
): Promise<CollectionWithCountAndFeaturedSpecial[]> {
  const searchParams = new URLSearchParams();

  if (params.collectionId) {
    searchParams.append("collection_id", params.collectionId);
  }
  if (params.comedianId) {
    searchParams.append("comedian_id", params.comedianId);
  }
  if (params.collectionId) {
    searchParams.append("collection_id", params.collectionId);
  }
  if (params.paid !== undefined) {
    searchParams.append("paid", params.paid.toString());
  }
  if (params.kind !== undefined) {
    searchParams.append("kind", params.kind);
  }
  if (params.limit) {
    searchParams.append("limit", params.limit.toString());
  }
  if (params.specialsLimit) {
    searchParams.append("specials_limit", params.specialsLimit.toString());
  }

  const response = await APIGetRequest<{
    data: CollectionWithCountAndFeaturedSpecial[];
  }>(`/api/v2/public/collections?${searchParams.toString()}`);
  return response.data;
}

/**
 * Check if a comedian has any paid bundles (collections)
 */
export async function comedianHasBundles(comedianId: string): Promise<boolean> {
  try {
    const collections = await getCollections({
      comedianId,
      kind: "collection",
      limit: 1,
    });
    return collections.length > 0;
  } catch (error) {
    logException(error);
    return false;
  }
}
